import { render, staticRenderFns } from "./DialogoEnviarPedidoWhatsapp.vue?vue&type=template&id=33a3c8eb&scoped=true&"
import script from "./DialogoEnviarPedidoWhatsapp.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogoEnviarPedidoWhatsapp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3c8eb",
  null
  
)

export default component.exports